/** 회원사 업무 문의 */
export default class MemberCompanyInquiry {
    _id = '';
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    _targetType = '';
    get targetType() {
        return this._targetType;
    }
    set targetType(value) {
        this._targetType = value;
    }
    _type = '';
    get type() {
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    _title = '';
    get title() {
        return this._title;
    }
    _processingType = '';
    get processingType() {
        return this._processingType;
    }
    set processingType(value) {
        this._processingType = value;
    }
    set title(value) {
        this._title = value;
    }
    _body = '';
    get body() {
        return this._body;
    }
    set body(value) {
        this._body = value;
    }
    _createdAt = 0;
    get createdAt() {
        return this._createdAt;
    }
    set createdAt(value) {
        this._createdAt = value;
    }
    _isDeleted = 0;
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(value) {
        this._isDeleted = value;
    }
    _commentCount = 0;
    get commentCount() {
        return this._commentCount;
    }
    set commentCount(value) {
        this._commentCount = value;
    }
    _createdByHubName = '';
    get createdByHubName() {
        return this._createdByHubName;
    }
    set createdByHubName(value) {
        this._createdByHubName = value;
    }
    _createdBy = '';
    get createdBy() {
        return this._createdBy;
    }
    set createdBy(value) {
        this._createdBy = value;
    }
    /** 작성자 이름 */
    _createdByName = '';
    get createdByName() {
        return this._createdByName;
    }
    set createdByName(value) {
        this._createdByName = value;
    }
    /** 덧글  */
    _commentContent = '';
    get commentContent() {
        return this._commentContent;
    }
    set commentContent(value) {
        this._commentContent = value;
    }
    _commentCreatedAt = '';
    get commentCreatedAt() {
        return this._commentCreatedAt;
    }
    set commentCreatedAt(value) {
        this._commentCreatedAt = value;
    }
    _commentProcessingType = '';
    get commentProcessingType() {
        return this._commentProcessingType;
    }
    set commentProcessingType(value) {
        this._commentProcessingType = value;
    }
    constructor(_data) {
        if (!_data) {
            return;
        }
        const data = this.translate(_data);
        Object.assign(this, data);
    }
    /**
     * 서버 응답값을 프론트에서 사용할 형태로 번역
     * back -> front
     * @returns
     */
    // eslint-disable-next-line class-methods-use-this
    translate(data) {
        return {
            ...data,
        };
    }
}
